import { useState } from 'react';

import DragAndDropFilesProco from './DragAndDropFilesProco';

import classes from './DropFilesHidden.module.css'

export default function DropFilesHiddenProco({children, uploadfile, uploadPermission}) {

    const [showdropFiles, setShowDropFiles] = useState(false)

    let dragTimer;
    function dragOverHandler(e) {
        if (uploadPermission) {
            var dt = e.dataTransfer;
            if (dt.types && (dt.types.indexOf ? dt.types.indexOf('Files') !== -1 : dt.types.contains('Files'))) {
                setShowDropFiles(true)
                window.clearTimeout(dragTimer);
            }
        }
        
    }

    function dragLeaveHandler() {
        dragTimer = window.setTimeout(function() {
            setShowDropFiles(false)
        }, 100);
    }

    function removeFilesHandler() {
        setShowDropFiles(false)
    }

    return <div className={classes.container} onDragOver={dragOverHandler} onDragLeave={dragLeaveHandler}>
        <div className={classes.container_inner}>
            {children}
        </div>
        {showdropFiles && <DragAndDropFilesProco removeFiles={removeFilesHandler} uploadfile={uploadfile}/>}
    </div>
}